<button
  mat-flat-button
  class="custom-button"
  [class]="buttonClasses"
  [disabled]="disabled"
  [type]="type"
  [ngStyle]="buttonStyles"
  (click)="onClick()">
  
  @if (iconLeft) {
    <mat-icon class="icon-left">{{ iconLeft }}</mat-icon>
  }
  
  {{ text }}
  
  @if (iconRight) {
    <mat-icon class="icon-right">{{ iconRight }}</mat-icon>
  }
</button>
